module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    ref: "theform",
    attrs: {
      "id": "contact"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.mail(_vm.$refs.theform)
      }
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column text-center"
  }, [_c('h2', [_vm._v("Contact Us")]), _vm._v(" "), _c('p', [_vm._v("Call or email us if you have any questions.")]), _vm._v(" "), _c('div', {
    staticClass: "row details"
  }, [_c('div', {
    staticClass: "column text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "//dsbn.org/walkerlivingcampus/img/contact-location.png",
      "alt": "Location"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("\r\n              2984 Holland Road"), _c('br'), _vm._v("Fonthill"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://goo.gl/maps/nnUiS4QVZnr",
      "target": "_blank"
    }
  }, [_vm._v("Get Directions")])])]), _vm._v(" "), _c('div', {
    staticClass: "column text-center"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "//dsbn.org/walkerlivingcampus/img/contact-phone.png",
      "alt": "Phone"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("905-892-5719")])])])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "contact-form"
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "_recipient",
      "value": "AdventureCampus"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_subject",
      "value": "Adventure Campus Contact Form"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_preface",
      "value": "Someone wanted to get in contact with you from dsbn.org/adventurecampus"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "hidden": "",
      "id": "loading"
    }
  }, [_vm._v("Loading")]), _vm._v(" "), _c('div', {
    staticClass: "error",
    attrs: {
      "hidden": "",
      "id": "error"
    }
  }, [_vm._v("Error sending message")]), _vm._v(" "), _c('h3', {
    staticClass: "success",
    attrs: {
      "hidden": ""
    }
  }, [_vm._v("Thank you for contacting us!")]), _vm._v(" "), _c('div', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column form-field"
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "id": "Name",
      "name": "Name",
      "type": "text",
      "placeholder": "Your Name"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column form-field"
  }, [_c('input', {
    attrs: {
      "id": "Email",
      "name": "Email",
      "type": "text",
      "placeholder": "Your E-mail"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column form-field"
  }, [_c('textarea', {
    attrs: {
      "autocomplete": "off",
      "name": "Message",
      "id": "Message",
      "placeholder": "Your Message"
    }
  })])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81334182","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tags/ContactForm.vue
// module id = 379
// module chunks = 0